<template>
    <div class="header-warp">
        <div class="header-logo">
            <img src="@/images/temporary/logo.png" alt="Logo">
        </div>
        <div class="header-links">
            <Select v-model="lang" style="width:80px;" @on-change="changeLang">
                <Option v-for="item in langs" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <h3>{{timeStr}}&nbsp;&nbsp;&nbsp;&nbsp;{{user}}&nbsp;[{{rank}}]</h3>
            <Tooltip content="全屏" placement="bottom">
                <Icon type="md-expand" size="24" style="cursor:pointer;margin-right:15px;" @click="fullScreen"/>
            </Tooltip>
            <Tooltip content="退出" placement="bottom">
                <Icon type="md-exit" size="24" style="cursor:pointer;" @click="logout"/>
            </Tooltip>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import Moment from 'moment';

export default {
    data() {
        return {
            langs: [
                {
                    value: 'zh-cn',
                    label: '中文'
                },
                {
                    value: 'en-us',
                    label: 'English'
                }
            ], // 多语言
            lang: this.$i18n.locale, // 当前语言
            timeStr: '----/--/-- --:--:--', // 时间表
            intvalTime: '', // 定时刷新时间
            ranks: [this.$t('rank0'), this.$t('rank1'), this.$t('rank2')] // 等级列表
        };
    },
    computed: {
        fid() {
            return this.$store.state.fid;
        },
        // 当前用户等级
        rank() {
            return this.ranks[this.$store.state.user.rank];
        },
        // 当前用户
        user() {
            return this.$store.state.user.name;
        }
    },
    created() {
        this.intvalTime = setInterval(() => {
            this.timeStr = Moment().format('YYYY/MM/DD HH:mm:ss');
        }, 1000); // 定时刷新时间
    },
    beforeDestroy() {
        clearInterval(this.intvalTime);
    },
    methods: {
        // 全屏
        fullScreen() {
            let el = document.documentElement;
            let isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
            if (!isFullscreen) {
                //进入全屏,多重短路表达式
                (el.requestFullscreen && el.requestFullscreen()) || (el.mozRequestFullScreen && el.mozRequestFullScreen()) || (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) || (el.msRequestFullscreen && el.msRequestFullscreen());
            } else {
                //退出全屏,三目运算符
                document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : '';
            }
        },
        // 切换语言
        changeLang(value) {
            this.$i18n.locale = value;
            this.ranks = [this.$t('rank0'), this.$t('rank1'), this.$t('rank2')]; //不加不会跟着切换语言
            //再把root中的设备类型修改一遍
            this.$root.deviceKind = [
                {
                    value: 1,
                    name: this.$t('b_MoldTemp')
                },
                {
                    value: 2,
                    name: this.$t('b_ThreeMachineDF')
                },
                {
                    value: 3,
                    name: this.$t('b_CoolingWater')
                },
                {
                    value: 4,
                    name: this.$t('b_Cadryer')
                },
                {
                    value: 5,
                    name: this.$t('b_ConveyorBelt')
                },
                {
                    value: 6,
                    name: this.$t('b_AutoFeedingController')
                },
                {
                    value: 7,
                    name: this.$t('b_Robot1100')
                },
                {
                    value: 8,
                    name: this.$t('b_InjectionJSU')
                },
                {
                    value: 9,
                    name: this.$t('b_TMC')
                },
                {
                    value: 10,
                    name: this.$t('b_Dryer')
                },
                {
                    value: 12,
                    name: this.$t('b_InjectionKLS')
                },
                {
                    value: 13,
                    name: this.$t('b_Robot990')
                },
                {
                    value: 14,
                    name: this.$t('b_ThreeMachineSF')
                },
                {
                    value: 20,
                    name: this.$t('b_Mold')
                },
                {
                    value: 21,
                    name: this.$t('b_AutoDetection')
                }
            ]
            sessionStorage.setItem('lang', value);
        },
        // 登出
        logout() {
            sessionStorage.removeItem('user');
            this.$store.commit('upUser', null);
            this.$router.push('login'); // 跳转到login
        }
    }
};
</script>
<style lang="less">
.header-warp {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    height: 45px;
    padding: 0 15px;
    background-color: #009dd0;
    background-image: -webkit-linear-gradient(left, #07aa9b, #009dd0);
    background-image: linear-gradient(to right, #07aa9b, #009dd0);
    background-repeat: no-repeat;
}

.header-logo {
    height: 100%;
    padding: 5px 35px 5px 20px;
    img {
        height: 100%;
    }
}
.header-links {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    h3 {
        padding: 0 15px;
        color: white;
    }
    .ivu-icon-md-expand {
        font-size: 24px;
        color: white;
    }
    .ivu-icon-md-exit {
        font-size: 24px;
        color: white;
    }
    .ivu-select-selection {
        border-color: #36b9a1;
        background-color: #0390bb;
        color: #fff;
    }
    .ivu-select-dropdown {
        background-color: #0390bb;
        .ivu-select-item {
            color: #fff;
        }
        .ivu-select-item:hover {
            background-color: #07aa9b;
        }
        .ivu-select-item-selected {
            background-color: #07aa9b;
        }
    }
    .ivu-icon {
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/main_components/header.vue